import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const ToggledIcon = svgProps => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 14",
    height: getDefaultHeight(svgProps, 14),
    ...svgProps,
    children: [/*#__PURE__*/jsx("rect", {
      y: "8.1",
      width: "13",
      height: "5.9",
      rx: "3",
      fill: "#090B19"
    }), /*#__PURE__*/jsx("ellipse", {
      cx: "9.8",
      cy: "11",
      rx: "2.1",
      ry: "2",
      fill: "#fff"
    }), /*#__PURE__*/jsx("rect", {
      width: "13",
      height: "6.1",
      rx: "3.1",
      fill: "#090B19",
      fillOpacity: ".2"
    }), /*#__PURE__*/jsx("ellipse", {
      cx: "3.3",
      cy: "3.1",
      rx: "2.2",
      ry: "2",
      fill: "#fff"
    })]
  });
};

export { ToggledIcon };
//# sourceMappingURL=toggled.js.map
